export const nSource = { //1banner
    wrapper: {
        className: 'banner3 news-banner banner-phone-size'
    },
    textWrapper: {
        className: 'banner3-text-wrapper',
        children: [{
            name: 'slogan',
            className: 'banner3-slogan',
            children: '东润资讯',
            texty: true,
        }]
    }
};

export const jobSource = { //1banner
    wrapper: {
        className: 'banner3 job-banner banner-phone-size'
    },
    textWrapper: {
        className: 'banner3-text-wrapper',
        children: [{
            name: 'slogan',
            className: 'banner3-slogan',
            children: '<p>诚邀有识之士加盟共创伟业,东润数字能源前进的路上有您、有我、有大家与您携手共同发展一起向未来</p>',
            texty: true,
        }]
    }
};

export const jobSource2 = {
    wrapper: {  className: 'banner3 job-banner banner-phone-size' },
    textWrapper: {
        className: 'banner3-text-wrapper banner3-text-wrapperjob',
        children: [
          
            {
                name: 'slogan',
                className: 'banner3-name1',
                children: '东润数字能源',
                //texty: true,
            },
            {
                name: 'name',
                className: 'banner3-name2',
                children: '诚邀有识之士加盟',
              //  texty: true,
            },
            {
                name: 'name',
                className: 'banner3-name4',
                children: '创业路上有您、有我、有大家',
            },
            {
                name: 'name',
                className: 'banner3-name3',
                children: '与您携手  共同发展',
            },
            {
                name: 'name',
                className: 'banner3-name3',
                children: '一起向未来',
            },
        
           
        ],
    },
};


